import { Action, createReducer, on } from '@ngrx/store';
import * as TenantsActions from '../actions/tenants.actions';
import { Tenants, TenantsDTO, TenantsFilters } from '../../commons/models/tenants';
import * as AuthActions from '../actions/auth.actions';
export interface TenantState {
  list: TenantsDTO[],
  total: number,
  includes: string[],
  currentPage: number,
  perPage: number,
  order: string,
  direction: string,
  filters: TenantsFilters,
  dialogId: string,
  selectionDialogId: string,
  tenants: TenantsDTO,
  selectedStoreTenant: TenantsDTO
};

const initialState: TenantState = {
  list: [],
  total: 0,
  includes: [],
  currentPage: 1,
  perPage: 25,
  order: null,
  direction: null,
  filters: null,
  dialogId: null,
  selectionDialogId: null,
  tenants: null,
  selectedStoreTenant: null
};

const tenantsReducer = createReducer(
  initialState,
  on(TenantsActions.loadTenantsCompleted, (state, { tenants, currentPage, total, perPage, order, direction, filters, includes }) => {
    return { ...state, list: tenants, currentPage, total, perPage, order, direction, filters, includes };
  }),

  on(TenantsActions.selectStoreTenant, (state, { tenant }) => {
    return { ...state, selectedStoreTenant: tenant };
  }),

  // Pulisce il tenant al logout
  on(AuthActions.logoutCompleted, (state) => {
    return { ...state, selectedStoreTenant: null };
  }),

  on(TenantsActions.tenantDialogOpened, (state, {dialogId}) => {
    return {...state, dialogId};
  }),
);

export function reducer(state: TenantState | undefined, action: Action) {
  return tenantsReducer(state, action);
}

